/* Visit Furniture: predictive search for all departments; native full-search sections for an exact department scope. */
(function () {
  'use strict';
  const strings = window.sigSearchStrings || {};
  const money = window.sigMoney || {};
  const helper = window.vfSearch;
  if (!helper) return; // The regular GET search form remains usable.
  const headings = { products: strings.products || 'Products', collections: strings.collections || 'Collections', queries: strings.queries || 'Suggestions' };
  function safeUrl(value, fallback) {
    try { const u = new URL(value, window.location.origin); return /^https?:$/.test(u.protocol) ? u.href : fallback; }
    catch (_) { return fallback; }
  }
  function price(value) {
    if (value == null || value === '' || !money.currency) return '';
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    try { return new Intl.NumberFormat(money.locale || undefined, { style: 'currency', currency: money.currency }).format(n); }
    catch (_) { return ''; }
  }
  function hit(item, kind) {
    const a = document.createElement('a'); a.className = 'search-hit';
    a.href = safeUrl(item.url, helper.root + 'search');
    const img = item.featured_image && item.featured_image.url;
    if (img) {
      const image = document.createElement('img'); image.className = 'search-hit__img';
      image.src = safeUrl(img, ''); image.alt = ''; image.loading = 'lazy'; image.width = 48; image.height = 48;
      a.appendChild(image);
    }
    const body = document.createElement('span'); body.className = 'search-hit__body';
    const title = document.createElement('span'); title.className = 'search-hit__title';
    title.textContent = item.title || item.text || '';
    body.appendChild(title);
    if (kind === 'products' && item.available === false && strings.outOfStock) {
      const stock = document.createElement('span'); stock.className = 'search-hit__stock'; stock.textContent = strings.outOfStock; body.appendChild(stock);
    }
    a.appendChild(body);
    const formatted = kind === 'products' ? price(item.price) : '';
    if (formatted) { const p = document.createElement('span'); p.className = 'search-hit__price'; p.textContent = formatted; a.appendChild(p); }
    return a;
  }
  function group(kind, items) {
    const wrap = document.createElement('div'); wrap.className = 'search-results__group';
    const h = document.createElement('p'); h.className = 'search-results__heading'; h.textContent = headings[kind]; wrap.appendChild(h);
    const ul = document.createElement('ul'); ul.className = 'search-results__list';
    items.forEach((item) => { const li = document.createElement('li'); li.appendChild(hit(item, kind)); ul.appendChild(li); });
    wrap.appendChild(ul); return wrap;
  }
  function wire(input, results) {
    let controller = null, timer = null, revision = 0;
    const form = input.closest('form');
    const scope = form && form.querySelector('[data-search-scope]');
    const popular = form && form.querySelector('[data-popular-searches]');
    function expanded(open) { if (input.hasAttribute('aria-expanded')) input.setAttribute('aria-expanded', String(open)); }
    function togglePopular() { if (popular) popular.hidden = !(document.activeElement === input && !input.value.trim()); }
    function cancel() { revision++; clearTimeout(timer); if (controller) controller.abort(); controller = null; }
    function clear() { results.replaceChildren(); expanded(false); }
    function dismiss() { cancel(); clear(); }
    function render(data, typed, tag, failed) {
      clear();
      for (const kind of ['queries', 'products', 'collections']) {
        if (Array.isArray(data[kind]) && data[kind].length) results.appendChild(group(kind, data[kind]));
      }
      if (!results.childNodes.length) {
        const note = document.createElement('p'); note.className = 'text-muted';
        note.textContent = failed ? 'Suggestions are unavailable. Open the full search results below.' : (strings.noResults || 'No matches — try a room or product type.');
        results.appendChild(note);
      }
      const all = document.createElement('a'); all.className = 'btn btn--quiet search-results__all';
      all.href = helper.url(typed, tag).href; all.textContent = strings.viewAll || 'View all results'; results.appendChild(all);
      expanded(true);
      if (window.sigAnnounce) window.sigAnnounce(strings.updated || 'Results updated');
    }
    function schedule() {
      cancel(); clear(); togglePopular();
      const typed = input.value.trim();
      if (typed.length < 2) return;
      const tag = helper.scopeTag(scope && scope.value);
      const version = revision;
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          let data;
          if (tag) {
            const url = helper.url(typed, tag); url.searchParams.set('section_id', 'vf-scoped-search');
            const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Scoped search response failed');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const node = doc.querySelector('[data-vf-search-payload]');
            if (!node) throw new Error('Scoped search payload missing');
            data = JSON.parse(node.textContent);
            if (!Array.isArray(data.products)) throw new Error('Invalid scoped search payload');
          } else {
            const url = new URL(helper.root + 'search/suggest.json', window.location.origin);
            url.searchParams.set('q', typed); // Predictive search does NOT support tag query syntax.
            url.searchParams.set('resources[type]', 'product,collection,query');
            url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            const response = await fetch(url.href, { signal: controller.signal, credentials: 'same-origin' });
            if (!response.ok) throw new Error('Predictive search response failed');
            const body = await response.json(); data = body.resources && body.resources.results;
            if (!data) throw new Error('Predictive search payload missing');
          }
          if (version === revision) render(data, typed, tag, false);
        } catch (error) {
          if (error.name !== 'AbortError' && version === revision) render({}, typed, tag, true);
        }
      }, 200);
    }
    input.addEventListener('input', schedule);
    input.addEventListener('focus', togglePopular);
    if (scope) scope.addEventListener('change', schedule);
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.stopPropagation(); dismiss(); }
      if (event.key === 'ArrowDown') { const first = results.querySelector('a'); if (first) { event.preventDefault(); first.focus(); } }
    });
    results.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dismiss(); input.focus(); return; }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = Array.from(results.querySelectorAll('a')); const i = links.indexOf(document.activeElement);
      if (i < 0) return;
      event.preventDefault(); const next = i + (event.key === 'ArrowDown' ? 1 : -1);
      if (next < 0) input.focus(); else if (links[next]) links[next].focus();
    });
    document.addEventListener('click', (event) => { if (!results.contains(event.target) && event.target !== input && event.target !== scope) dismiss(); });
    document.addEventListener('focusin', () => { if (!popular || !popular.contains(document.activeElement)) togglePopular(); });
    window.addEventListener('pagehide', dismiss);
  }
  document.querySelectorAll('[data-predictive-input]').forEach((input) => {
    const form = input.closest('form'), dialog = input.closest('dialog');
    const results = (form && form.querySelector('[data-predictive-results]')) || (dialog && dialog.querySelector('[data-predictive-results]'));
    if (results) wire(input, results);
  });
})();
